module.exports = __webpack_public_path__ + "media/images/2_2_1-5b16dd1699f25b943f2060efadf7b74a.png";